import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5468b067"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "lock-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasTestAgency)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(`${_ctx.isConnectDisabled ? 'ai-premium-lock-image' : 'ai-premium-image'}`)
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(`btn btn-md btn-save-notify ms-2 ${_ctx.buttonClasses}`),
          disabled: _ctx.isConnectDisabled,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveVisit()))
        }, [
          _createTextVNode(_toDisplayString(_ctx.buttonName) + " ", 1 /* TEXT */),
          (_ctx.isConnectDisabled)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2))
            : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_1)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}